import React, { useState } from 'react';
import api from '../../services/api';
import InputMask from 'react-input-mask';
import { useSelector } from 'react-redux';
import Swal from 'sweetalert2';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
//import history from '../../services/history';
import './styles.css'

export default function AddRequerimento({ onSubmit }) {

    const { usuario } = useSelector((state) => state.auth);

    const [documentoMotorista, setDocumentoMotorista] = useState('');
    const [email, setEmail] = useState('');
    const [placa, setPlaca] = useState('');
    const [declaracaoCiencia, setDeclaracaoCiencia] = useState(false);

    const handleCheckboxChange = (e) => {
		const target = e.target;
		const value = target.type === 'checkbox' ? target.checked : target.value;
		setDeclaracaoCiencia(value);
    }
    
    const handleSubmit = async (e) => {
        e.preventDefault();        
        
        const requerimento = {
            cnpj: usuario,
            documentoMotorista,
            email,
            placa: placa.replace('-', ''),
            declaracaoCiencia
        }

        try {
            await api.post("/requerimento", requerimento);
            await Swal.fire("Registro salvo com sucesso!", "", "success");
            setDocumentoMotorista("");
            setEmail("");
            setPlaca("");
            setDeclaracaoCiencia(false);            
        } catch (error) {
            console.log(error);
            Swal.fire("Ocorreu um erro ao salvar!", "", "error");
            return;
        }
        
    }

    return (
        <form onSubmit={handleSubmit} className="requerimentos">
			<h1 className="title">
				Requerimento
			</h1>
			<h2 className="subtitle">
				Cadastrar Requerimento
			</h2>

			<div className="field">
				<label className="label" htmlFor="razaoSocial">Documento do Motorista</label>
				<div className="control">
					<input
                        id="documentoMotorista"
						name="documentoMotorista"
						className="input"
						required
						value={documentoMotorista}
						onChange={e => setDocumentoMotorista(e.target.value)}
					/>
				</div>
			</div>

			<div className="field">
				<label className="label" htmlFor="email">E-mail</label>
				<div className="control">
					<input
                        id="email"
                        type="email"
						name="email"						
						className="input"
						required
						value={email}
						onChange={e => setEmail(e.target.value)}
					/>
				</div>
			</div>

			<div className="field">
				<label className="label" htmlFor="placa">Placa</label>
				<div className="control">
					<InputMask
                        id="placa"
						name="placa"						
						className="input"
						required
						value={placa}
						mask="aaa-9*99"
						onChange={e => setPlaca(e.target.value)}
					/>
				</div>
			</div>		

            <div className="field">
                <div className="control">
                    <label className="checkbox">
                        <input
                            type="checkbox"
                            checked={declaracaoCiencia}
                            onChange={handleCheckboxChange}
                        /> Declaração conforme o Inciso X do Art. 4º da Lei Nº 7.225, de 14 de Outubro de 2019.
                    </label>
                </div>
            </div>

            <div className="field is-grouped">
                <p className="control">
                    <button className="button is-success" type="submit">
                        Salvar
                    </button>
                </p>
                <p className="control">
					<Link to={`/requerimentos`} className="button is-light">Requerimentos</Link>
				</p>
            </div>
		</form>
    );
}